import { Box, Typography } from '@mui/material';
import React from 'react';
import HdIcon from '../../../media/components/icon/HdIcon';
import styles from './NoMatchAlert.module.scss';

export interface NoMatchAlertProps {
  titleComponent?: any;
  titleComponentProps?: any;
  subTextComponent?: any;
  subTextComponentProps?: any;
  actionsComponent?: any;
  actionsComponentProps?: any;
}

export function  NoMatchAlert({
  titleComponent,
  titleComponentProps = {},
  subTextComponent,
  subTextComponentProps = {},
  actionsComponent,
  actionsComponentProps = {}
}: NoMatchAlertProps) {

  const TitleComponent = titleComponent;
  const SubTextComponent = subTextComponent;
  const ActionsComponent = actionsComponent;

  return (
    <Box className={styles.alertWrapper}>
      <div className='no-item-box-icon-container'>
        <HdIcon name='search' className='no-item-box-icon' />
      </div>

      <div className={styles.text}>
        {titleComponent ? (
          <Typography variant='subtitle2' component='h4' className='text-ellipsis'>
            <TitleComponent {...titleComponentProps} />
          </Typography>
        ) : null}

        {subTextComponent ? (
          <Typography component='span' className={styles.subtext}>
            <SubTextComponent {...subTextComponentProps} />
          </Typography>
        ) : null}
      </div>

      {actionsComponent ? (
        <div className={`${styles.action} mt-5`}>
          {' '}
          <ActionsComponent {...actionsComponentProps} />
        </div>
      ) : null}
    </Box>
  );
}
